import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import { isEmpty } from 'lodash'

import { MastitisClassification } from '#/@types/backend'
import CowmedChip from '#/components/Chip'
import Colors from '#/styles/Colors'

export type CCSStatusValue = {
  status: MastitisClassification
  text: string
}

interface TypeCCSStatusProps {
  value: CCSStatusValue
}

const Dot = styled(Box)({
  borderRadius: '50%',
  display: 'inline-block',
  height: 6,
  width: 6,
})

export function TypeCCSStatus({ value }: TypeCCSStatusProps) {
  if (isEmpty(value)) return <span>-</span>

  const { status, text } = value
  const style = Colors.ccs_status[status]

  return (
    <CowmedChip
      value={text}
      width="unset"
      style={style}
      sx={{ paddingLeft: 0.5 }}
      icon={<Dot style={{ backgroundColor: style?.color }} />}
    />
  )
}
